import {setConfig,isDate,isValidPhone, isValidEmail,isInteger,isDecimal,isFloat,isBefore} from "./validations";

export const formatDate = (date, format = "MM/dd/yyyy") => {
	return date;
	//return date ? moment(new Date(date)).format(format.toUpperCase()) !== 'Invalid date' ? moment(new Date(date)).format(format.toUpperCase()) : date : null;
};


export const textEllipsis = (text, size) => {
	return ((text).length > size) ? (((text).substring(0, size - 3)) + '...') : text
}

export const validateForm = (fields, values, config) => {
	config.view = config.view?config.view:'createview';
	window.calendar_format = config.calendar_format; 
	window.date_reg_format = config.date_reg_format; 
	window.time_reg_format = config.time_reg_format;
	window.date_reg_positions = config.date_reg_positions;
	let requiredTxt = 'Missing Required Field:';
	let invalidTxt = 'Invalid Value: ';
	let errors = {};
	let formIsValid = true;

	// eslint-disable-next-line no-lone-blocks
	{
		Object.keys(fields).map((fieldNum) => {
			let field = fields[fieldNum];			
			// console.log(field)
			if(field.name==='case_number')
			{
				field.required=false;
			}
			if (field.type==='relate' && field.required === 'true' &&  (!values[field.name] || !values[field.name].id || !values[field.name].id.length)) {
				formIsValid = false;
				errors[field.name] = '*' +requiredTxt+ field.label;
			}
			else if (field.type==='file' && field.required === 'true' && (config.view==='createview' || config.view==="editview")) {
				// console.log(field)
				if(values.filename[0].name===null)
				{

					formIsValid = false;
					errors[field.name] = '*' +requiredTxt+ field.label;	
					console.log(errors)
				}
				// else if(!values[field.name][0].file_name && !values[field.name][0].file_content){
				// formIsValid = false;
				// errors[field.name] = '*' +requiredTxt+ field.label;
				// }
			}else if (field.type!=='relate' && field.required === 'true' && (!values[field.name] || !values[field.name].length)) {
				formIsValid = false;
				errors[field.name] = '*' +requiredTxt+ field.label;
			}
			
			/* validation for date between for Meetings modules */
			if(field.name==='date_start' && values[field.name] && values['date_end'])
			{
				if(!isBefore(values[field.name],values['date_end'])){
					formIsValid = false;
					errors[field.name] = `${field.label} (${values[field.name]}) is not before ${values['date_end']}`
				}
			}
			/* validation for date between for Tasks modules */			
			if(field.name==='date_start' && values[field.name] && values['date_due'])
			{
				if(!isBefore(values[field.name], values['date_due'])){
					formIsValid = false;
					errors[field.name] = `${field.label} (${values[field.name]}) is not before ${values['date_due']}`;
				}
			}

			switch(field.type)
			{
				case 'phone':
					if(values[field.name] && !isValidPhone(values[field.name].trim()))
					{
						formIsValid = false;
						errors[field.name] = invalidTxt+field.label;
					}
					break;
				case 'email':
					if(values[field.name] && values[field.name].length>0)
					{
						if(Array.isArray(values[field.name]))
						{
							values[field.name].map((emaiField,key)=>{
								if (!isValidEmail(emaiField.email.trim())) {
									formIsValid = false;
									errors[field.name+''+key] = invalidTxt+field.label;
								}
							})
							
						}
					}else{
						formIsValid = false;
						errors[field.name+''+0] = requiredTxt+ field.label;
					}
					break;
				// case 'date':
				// case 'datetimecombo':
				// 	if(!isDate(values[field.name].trim()))
				// 	{
				// 		formIsValid = false;
				// 		errors[field.name] = invalidTxt+field.label;
				// 	}
				// 	break;
				
				case 'int':
					if(values[field.name] && !isInteger(values[field.name]))
					{
						formIsValid = false;
						errors[field.name] = invalidTxt+field.label;
					}
					break;
				case 'decimal':
					if(values[field.name] && !isDecimal(values[field.name]))
					{
						formIsValid = false;
						errors[field.name] = invalidTxt+field.label;
					}
					break;
				//case 'currency':
				case 'float':
					if(values[field.name] && !isFloat(values[field.name]))
					{
						formIsValid = false;
						errors[field.name] = invalidTxt+field.label;
					}
					break;
				case 'url':
				case 'iframe':
					let isValidUrl = new RegExp(/^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/);
					if (values[field.name] && values[field.name].trim() && !isValidUrl.test(values[field.name].trim())) {
						formIsValid = false;
						errors[field.name] = invalidTxt+field.label;
					}
					break;
				case 'user_name':
					if (values[field.name] && !values[field.name].match(/^[a-zA-Z-.]*$/)) {
						formIsValid = false;
						errors[field.name] = '*Please enter alphabet characters only.';
					}
					break;
				case 'password':
					if(values['old_password'] && values['old_password'].trim())
					{
						let passwordExp = /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%&]).*$/;
						//formIsValid = false;
						//errors['old_password'] = '*Please enter your password.';

						if(!values['new_password'].trim())
						{
							formIsValid = false;
							errors['new_password'] = requiredTxt+" New password";
						}
						if(!values['confirm_new_password'].trim())
						{
							formIsValid = false;
							errors['confirm_new_password'] = requiredTxt+"Confirm new password";
						}

						if(values['new_password'].trim() !== values['confirm_new_password'].trim())
						{
							formIsValid = false;
							errors['new_password'] = '*Confirm password is not matching.';
						}
						if (values['new_password'].trim() && !values['new_password'].trim().match(passwordExp)) {
							formIsValid = false;
							errors['new_password'] = '*Please enter secure and strong password.';
						}

						if (values['confirm_new_password'].trim() && !values['confirm_new_password'].trim().match(passwordExp)) {
							formIsValid = false;
							errors['confirm_new_password'] = '*Please enter secure and strong password.';
						}
					}
					break;
				default:
					break;
			}
			
		});
	}
	return { formIsValid: formIsValid, errors: errors };
};
export const getBase64 = (file, cb) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		// reader.onload = () => resolve({ 'name': file.name, 'file_content': reader.result.replace(/^data:.+;base64,/, '') });
		reader.onload = () => resolve({ 'name': file.name, 'file_content': reader.result });
		reader.onerror = error => reject(error);
	});
}
export const downloadFile = async (site_url,filename,id,module='') => {
	return;  
  };